import { BlobParsedStatus, ScheduleCheckFileType, } from '@consigli/types';
import { useCallback } from 'react';
import { useCreateBlobMutation } from '../api';
import { useFileUpload } from './use-file-upload';
import { useProjectId } from './use-project-id';
/**
 * Hook to upload a file and create a blob
 *
 * @returns an upload function
 */
export const useBlobUpload = () => {
    const projectId = useProjectId();
    const { upload: uploadFile } = useFileUpload();
    const [createBlob] = useCreateBlobMutation();
    const upload = useCallback(async (file, packageId, onProgress, additionalMetadata) => {
        const uploadedFile = await uploadFile(file, projectId, onProgress);
        // Determine schedule_check_file_type if applicable
        let scheduleCheckFileType;
        if (file.isScheduleFile) {
            scheduleCheckFileType = ScheduleCheckFileType.SCHEDULE_FILE;
        }
        else if (file.isDrawing) {
            scheduleCheckFileType = ScheduleCheckFileType.DRAWINGS;
        }
        else if (file.isSchematicDrawing) {
            scheduleCheckFileType = ScheduleCheckFileType.SCHEMATIC_DRAWINGS;
        }
        const blobPayload = {
            documentPackage: packageId,
            name: file.name,
            parsedStatus: BlobParsedStatus.UPLOADED,
            originalFileId: uploadedFile.id,
            isDrawingIndexList: file.isDrawingIndexList ? file.isDrawingIndexList : false,
            isChecklist: file.isChecklist ? file.isChecklist : false,
            ...(scheduleCheckFileType && { scheduleCheckFileType }),
            ...((file.isSampleReport || file.waterProcessFileType || additionalMetadata) && {
                metadata: {
                    ...(file.isSampleReport && { isSampleReport: true }),
                    ...(file.waterProcessFileType && { waterProcessFileType: file.waterProcessFileType }),
                    ...additionalMetadata,
                },
            }),
        };
        return await createBlob({ projectId, packageId, data: blobPayload }).unwrap();
    }, [projectId, uploadFile, createBlob]);
    return {
        upload,
    };
};
